module.exports = __webpack_public_path__ + "static/media/allison-headshot-2015.0e1c63dd.jpg";